import { combineReducers } from "redux"
import authReducer from './authReducer'
import userAdminReducer from './userAdminReducer'
import userResellerReducer from './userResellerReducer'
import twoFAReducer from './twoFAReducer'
import gamesReducer from './gamesReducer'
import ordersReducer from './ordersReducer'
import resellersReducer from './resellersReducer'
import adminsReducer from './adminsReducer'
import settingsReducer from './settingsReducer'

export default combineReducers({
    auth: authReducer,
    userAdmin: userAdminReducer,
    userReseller: userResellerReducer,
    admins: adminsReducer,
    games: gamesReducer,
    orders: ordersReducer,
    resellers: resellersReducer,
    verifyToken: twoFAReducer,
    settings: settingsReducer,
})